<template>
  <div id="app" :class="{locked: isLocked}">
    <x-loader v-if="isLocked"/>
    <page-header/>
    <router-view></router-view>
  </div>
</template>
<script>
import pageHeader from './components/PageHeader.vue'
import xLoader from './components/Loader.vue'
import {EventBus} from './components/EventBus.js';

export default {
    name: 'app',
    components: {
      'page-header': pageHeader,
      'x-loader': xLoader,
    },
    data () {
      return {
        isLocked: false
      }
    },
    mounted () {
      var self = this;
      EventBus.$on('lock-interaction', function() {
        self.isLocked = true;
      });
      EventBus.$on('unlock-interaction', function() {
        self.isLocked = false;
      });
    }
  };
</script>
<style>

@font-face{
    font-family: 'AvenirLTPro-Roman';
    src: url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_0_0.eot");
    src: url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_0_0.eot?#iefix") format("embedded-opentype"), url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_0_0.woff2") format("woff2"), url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_0_0.woff") format("woff"), url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_0_0.ttf") format("truetype");
}

        @font-face {
            font-family: 'AvenirLTPro-Medium';
            src: url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_1_0.eot");
            src: url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_1_0.eot?#iefix") format("embedded-opentype"), url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_1_0.woff2") format("woff2"), url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_1_0.woff") format("woff"), url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_1_0.ttf") format("truetype");
        }

        @font-face {
            font-family: 'AvenirLTPro-Heavy';
            src: url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_2_0.eot");
            src: url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_2_0.eot?#iefix") format("embedded-opentype"), url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_2_0.woff2") format("woff2"), url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_2_0.woff") format("woff"), url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_2_0.ttf") format("truetype");
        }

        @font-face {
            font-family: 'AvenirLTPro-Black';
            src: url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_3_0.eot");
            src: url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_3_0.eot?#iefix") format("embedded-opentype"), url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_3_0.woff2") format("woff2"), url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_3_0.woff") format("woff"), url("https://www.xplora.fi/wp-content/themes/maksimer/webfonts/38E35E_3_0.ttf") format("truetype");
        }

.locked {
  pointer-events: none;
}
* {
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-family:'AvenirLTPro-Medium', sans-serif;
  -webkit-margin-before: 0px;
  -webkit-margin-after: 0px;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
  -webkit-padding-start: 0px;
}
ul {
  -webkit-padding-start: 20px;
}
body {
  padding: 0;
  margin: 0;
}
b {
  font-weight: 600;
}
h1, h2 {
  font-weight: normal;
}
.page {
  max-width: 1140px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 40px;
  overflow-x: hidden;
}
.page.wide {
  width: 100%;
  padding: 0;
}
.page.wide .content {
  width: 100%;
}
.page main {
  float: left;
  width: 100%;
}
a {
  /*text-decoration: none;*/
  color: #4DA8E5;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    opacity: 0.7; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
    opacity: 0.7;
}

::-ms-input-placeholder { /* Microsoft Edge */
    opacity: 0.7;
}
@media (max-width: 520px) {
  .page {
    padding: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue